import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { AddExpenseHead, AddPurpose, getExpenseList, getPolicyKeys, getPurposeList, getSingleExpense, getSinglePurpose, updateExpHead, UpdatePurpose } from './ExpenseRepo'
import { toast } from "react-toastify"
import { showToast } from "../../../../utils/toastUtils"




export const useALLExpese = ({ enable = false }) => {
  return useQuery({
    queryKey: ['GET_EXPENSE_LIST'],
    queryFn: getExpenseList,
    enabled: enable,
    retry: false
  })
}


export const useSingleExpense = ({ id, enable = false }: { id: number, enable: boolean }) => {
  return useQuery({
    queryKey: ['GET_EXPENSE_LIST', id],
    queryFn: () => getSingleExpense(id),
    retry: false,
    // enabled:enable,
    enabled: enable && !!id,
  })

}
export const useGetPolicyKeys = ({
  params = {},
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["POLICY_KEYS"],
    queryFn: getPolicyKeys,
    enabled: enable,
    retry: false,
  });
};


////////////////////////// PURPOSE //////////

interface AddRequestPurpose {
  title: string,
  budget: number,
  notes: string,
  expenses: number[],
  status: number,
  isDefault: Boolean
}

interface updateAPIinterface {
  id: number;
  title: string;
  budget: number;
  notes: string;
  expenses: number[];
  status: number;
  isDefault: boolean;
}


export const useSinlgePurpose =  ({id,enable = false}:{id:number,enable:boolean})=>{
    return useQuery({
           queryKey:['GET_PURPOSE_LIST',id],
           queryFn: ()=>getSinglePurpose(id),
           retry:false,
           enabled: enable
    })
}


export const useAllPurpose = ({ enable = false }) => {
  return useQuery({
    queryKey: ['GET_PURPOSE_LIST'],
    queryFn: getPurposeList,
    enabled: enable,
    retry: false
  })
}



export const useLeaveTypesData = ({
  params = {},
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["LEAVE_TYPES"],
    queryFn: getPolicyKeys,
    enabled: enable,
    retry: false,
  });
};

export const useAddPurpose = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ ReqBody }: { ReqBody: AddRequestPurpose }) => AddPurpose(ReqBody),
    onSuccess: () => {
       showToast.success("Purpose Added successfully!")
      queryClient.invalidateQueries({ queryKey: ['GET_PURPOSE_LIST'] });
    },
    onError: (error) => {
      console.log('Failsed to add Purpose', error.message);
       showToast.error("Failed to add Purpose. Please try again.")
    },
    retry: false
  })
}



// AddExpenseHead
export const useAddExpenseHead = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: AddExpenseHead,
    onSuccess: (data) => {
      showToast.success("Expense Head Added Successfully!");
      queryClient.invalidateQueries({ queryKey: ["GET_EXPENSE_LIST"] });
      // <Loader />
    },
    onError: (error) => {
     showToast.error("Failed to Add  Expense Head!");
    },
  });
}
export const useUpdateExpHead = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateExpHead,
    onSuccess: (data) => {
      showToast.success("Update Successfully!");
      queryClient.invalidateQueries({ queryKey: ["GET_EXPENSE_LIST"] });
      // <Loader />
    },
    onError: (error) => {
     showToast.error("Failed to update  Expense Head!");
      console.log('Faield to update Expense Head!',error.message);
    },
  });
}

export const useUpdatePurpose = () => {
  const queryClient = useQueryClient();
    
  return useMutation({
    mutationFn: ({ ReqBody }: { ReqBody: updateAPIinterface }) => UpdatePurpose(ReqBody),

    onSuccess: () => {
      showToast.success("Purpose updated successfully!")
      queryClient.invalidateQueries({ queryKey: ['GET_PURPOSE_LIST'] });
    },

    onError: (error) => {
      showToast.error('Falied to update purpose Please try agin')
      console.log('Failsed to add Purpose', error.message);
    },
    retry: false
  })

}
